import {Component} from "react";
import Navbar from "../navbar";
import React from "react";


class HSamuelHeader extends Component {
    toogleWidth = 1310;
    isMobileLayout = false;

    state = {
        showSearchPanel: false,
    };


    render() {
        let styleHidden = {};
        this.isMobileLayout = window.innerWidth < this.toogleWidth;
        if (this.isMobileLayout)
            styleHidden = {display: 'none'};
        return (
            <div className="hsamuel">
                {/*<div className="promo-message">*/}
                    {/*<p className="promo-message__text">*/}
                        {/*<a href="https://www.hsamuel.co.uk/webstore/l/watches/price|on sale/select|luxury watches/?icid=ej-tn-gb-lw"*/}
                           {/*className="promo-message__link">Luxury watches sale | SHOP NOW</a>*/}
                    {/*</p>*/}
                {/*</div>*/}


                <div className="main-site-header__styles" style={styleHidden}>
                    <div className="u-container">
                        <div className="site-top-bar">
                            <ul className="js-top-bar top-bar">

                                <li className="top-bar__list-item">
                                    <a className="top-bar__link"
                                       href={window.baseSiteUrl + "/webstore/blog.cdo?icid=ej-tn-topbar-blog"}>
                                        Blog
                                    </a>
                                </li>

                                <li className="top-bar__list-item">
                                    <a className="top-bar__link"
                                       href={window.baseSiteUrl + "/webstore/secure/storeLocator.sdo?icid=ej-tn-topbar-store"}>
                                        Store Locator
                                    </a>
                                </li>

                                <li className="top-bar__list-item">
                                    <a className="top-bar__link"
                                       href={window.baseSiteUrl + "/webstore/static/customerservice/customerservice.do?icid=ej-tn-topbar-cs"}>
                                        Contact
                                    </a>
                                </li>

                                <li className="top-bar__list-item">
                                    <a className="top-bar__link"
                                       href={window.baseSiteUrl + "/webstore/compare.sdo?icid=ej-tn-topbar-compare"}>
                                        Compare
                                    </a>
                                </li>

                                <li className="top-bar__list-item">
                                    <a className="top-bar__link"
                                       href={window.baseSiteUrl + "/webstore/showWishlist.sdo?icid=ej-tn-topbar-wishlist"}>
                                        Wishlist
                                    </a>
                                </li>


                              
                            </ul>
                        </div>
                    </div>
                </div>

                <div className={this.isMobileLayout ? "mobile-navbar" : "desktop-navbar"}>
                    <div className="u-container u-container--icons desktop-header">
                        <div className="site-logo">
                            <a href={window.baseSiteUrl} className="territory">
                                <img src="https://www.hsamuel.co.uk/cms/images/logo.svg"
                                     alt="Ernest Jones, Love &amp; Life"/>
                            </a>
                        </div>

                        <Navbar model={this.props.model} toogleWidth={this.toogleWidth}>
                            {this.isMobileLayout &&
                            <div style={{display: 'flex'}}>
                             
                            </div>
                            }
                        </Navbar>
                        <div className="site-search" id="js-site-search" style={styleHidden}>
                            <form name="endecasearchform" id="js-main-search"
                                  action={window.currentSiteUrl + "/webstore/search.sdo"} role="search"
                                  method="post" noValidate="">
                                <input className="site-search__field" id="js-search-field" type="search"
                                       placeholder="What are you looking for?" autoComplete="off" list="search-hints"
                                       name="searchTerm"/>
                                <button className="site-search__submit" name="searchButton" type="submit">
                                    <i className="fa fa-search"></i>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
                {this.isMobileLayout && this.state.showSearchPanel &&
                <div className="site-search mobile-search">
                    <form name="endecasearchform" id="js-main-search"
                          action={window.baseSiteUrl + "/webstore/search.sdo"} role="search"
                          method="post" noValidate="">
                        <input className="site-search__field" id="js-search-field" type="search"
                               placeholder="What are you looking for?" autoComplete="off" list="search-hints"
                               name="searchTerm"/>
                        <button className="site-search__submit" name="searchButton" type="submit">
                            <i className="fa fa-search"></i>
                        </button>
                    </form>
                </div>
                }
            </div>
        )
    }
}

export default HSamuelHeader;


// WEBPACK FOOTER //
// ./src/site_interfaces/headers/hsamuel.js